import React from 'react';
import ExpansionConfigCard from './configurator-cards/ExpansionConfigCard.jsx';
import ExpansionSystemAttributesCard from './configurator-cards/ExpansionSystemAttributesCard';



const ExpansionSystemView = ({
    config,
    updateConfig,
    batchUpdateConfig,
    metrics,
    baselineMetrics,
    affectedKeys,
    staleKeys,
    pricingData,
    vendor,
    consultationMode,
    hasSpecialAccess,
    hasExecAccess = false, // CONF-212: gates Custom Metrics
    hasDualCpuAccess = false, // CONF-210/259: unlocks the Flash Node Model control
    execMetrics,
    showExecMetrics,
    onToggleExecMetrics,
}) => {

    const { branding, capabilities, businessRules, databases } = vendor;
    const productDb = databases.products;

    return (
        <>
        <ExpansionConfigCard
            config={config}
            updateConfig={updateConfig}
            batchUpdateConfig={batchUpdateConfig}
            productDb={productDb}
            hasSpecialAccess={hasSpecialAccess}
            hasDualCpuAccess={hasDualCpuAccess}
            theme={branding.theme}
            capabilities={capabilities}
            metrics={metrics}
        />
        <ExpansionSystemAttributesCard
            config={config}
            updateConfig={updateConfig}
            batchUpdateConfig={batchUpdateConfig}
            productDb={productDb}
            metrics={metrics}
            baselineMetrics={baselineMetrics}
            affectedKeys={affectedKeys}
            staleKeys={staleKeys}
            pricingData={pricingData}
            hardwareVendor={vendor.id}
            theme={branding.theme}
            consultationMode={consultationMode}
            hasExecAccess={hasExecAccess}
            execMetrics={execMetrics}
            showExecMetrics={showExecMetrics}
            onToggleExecMetrics={onToggleExecMetrics}
        />
        </>
    );
};

export default ExpansionSystemView;